import React from "react";
import { Typography } from "@mui/material";

let cachedJson, cachedHints;
export const getCitySuggestion = (json, section, index, field) => {
  if (!json) return null;
  try {
    if (json !== cachedJson) { cachedJson = json; cachedHints = JSON.parse(json); }
    const hints = cachedHints;
    return (section === "header" ? hints?.header?.[field] : hints?.houses?.[index]?.[field]) ?? null;
  } catch (_) { cachedHints = null; return null; }
};
export default function AiCitySuggestion({ suggestion, city, countryCode }) {
  const selected = typeof city === "string" ? city.trim() : city?.id || city?.cityName;
  if (!suggestion?.name || selected) return null;
  if (suggestion.countryCode && countryCode && suggestion.countryCode.toUpperCase() !== countryCode.toUpperCase()) return null;
  return <Typography component="span" variant="caption" color="text.secondary" display="block">
    AI suggestion: {suggestion.name}
  </Typography>;
}
